module.exports = __webpack_public_path__ + "static/media/news_1.cc70c71b.jpg";